import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from '../app.component';
import { Service } from '../services';
import { GlobalService } from '../global.service';
import { LoadingScreenService } from '../services/loading-screen/loading-screen.service';
import { Subscription } from "rxjs";
import { AngularFireAnalytics } from '@angular/fire/analytics';
@Component({
  selector: 'app-myorders',
  templateUrl: './myorders.component.html',
  styleUrls: ['./myorders.component.sass']
})
export class MyordersComponent implements OnInit {
  public tabActive='Compras';
  public selectBan;
  public banlist;
  public currentList;
  public postpago;
  public prepago;
  public telefoniaFijo;
  public totalAccountList;
  public type;
  public token:string=sessionStorage.getItem("token");
  loadObserver: Subscription;

  public isChecked=[];
  public paquetes=[];
  public SubscribersPackages=[];
  public contadorHtml=0;
  public data;

  constructor( private router:Router,public appComponent:AppComponent,private loadingScreenService :LoadingScreenService,private services: Service,public global:GlobalService,public AngularFireAnalytics:AngularFireAnalytics) {
    this.AngularFireAnalytics.setCurrentScreen("Historial de Compras");
    this.AngularFireAnalytics.logEvent("Historial de Compras-Screenview");
   }

  ngOnInit() {
    this.global.validateSession();
    this.banlist=JSON.parse(atob(sessionStorage.getItem("AccountList")));
    this.selectBan=atob(sessionStorage.getItem("selectBan"));
    this.getRecord();
    this.loadObserver = this.global.loadObserver.subscribe((value:number) => {
      this.dataLoading(value)
    });
  }
  refreshDataTo(event:Event) {
    let index =parseInt(event.target["selectedIndex"]);
    let ban = this.currentList[index].account;
    sessionStorage.setItem("selectBan",btoa(ban));
    this.initializeData();
  }
  initializeData(){
    this.global.refreshDataTo(this.token);
  }
  dataLoading(sw){
    if(this.postpago==true){
      this.type="postpaid";
      this.getRecord();
    }
    else if(this.prepago==true){
      this.type="prepaid";
      this.getRecord();
    }
    else if(this.telefoniaFijo==true){
      this.type="fixed";
      this.getRecord();
    }
  }
  getRecord(){
    this.loadingScreenService.startLoading();
    this.services.getTransacts(this.selectBan,this.token,).subscribe(data =>{
      this.loadingScreenService.stopLoading();
        if(data.HasError==false){
          this.data = data;
          this.SubscribersPackages=this.data.Subscribers;
          var paquetes='[';
          var contador=0;
          var contador2=0;
          var contador3=0;
          var sw1=false;
          var sw3=false;
          var sw5=false;
          var paqueteAnt=0;
          for (var i = 0; i < this.data.Subscribers.length; i++) {
            if(this.data.Subscribers[i].Packages!=null && this.data.Subscribers[i].Packages!=""){
              if(contador2>0){
                  paquetes+=',';
              }
              paquetes+='{"paquete":['
              for (var j = 0; j <this.data.Subscribers[i].Packages.length; j++) {
                  if(paqueteAnt!=this.data.Subscribers[i].Packages[j].OfferId && contador>0){
                      contador2++;
                      paquetes+='],"INDEX":"'+contador2+'","SUBSCRIBER":"'+this.data.Subscribers[i].SubcriberNumber+'"}';
                      paquetes+=',';
                      paquetes+='{"paquete":[';
                      contador=0;
                      contador3++;
                      paquetes+='{"INDEX":"'+contador+'","NOMBRE":"'+this.data.Subscribers[i].Packages[j].Name+'","BaseOfferID":"'+this.data.Subscribers[i].BaseOfferID+'","SUBSCRIBER":"'+this.data.Subscribers[i].SubcriberNumber+'","DESCRIPCION":"'+this.data.Subscribers[i].Packages[j].Desc+'","OfferID":"'+this.data.Subscribers[i].Packages[j].OfferId+'","COSTO":"'+parseFloat(this.data.Subscribers[i].Packages[j].Price).toFixed(2)+'","RENEWAL":"'+sw1+'","RENEWALACTIVE":'+sw3+',"RENEWALENABLE":'+sw5+'}';
                      paqueteAnt=this.data.Subscribers[i].Packages[j].OfferId;
                      contador++;
                  }
                  else{
                      if(contador>0){
                          paquetes+=',';
                      }
                      paquetes+='{"INDEX":"'+contador+'","NOMBRE":"'+this.data.Subscribers[i].Packages[j].Name	+'","BaseOfferID":"'+this.data.Subscribers[i].BaseOfferID+'","SUBSCRIBER":"'+this.data.Subscribers[i].SubcriberNumber+'","DESCRIPCION":"'+this.data.Subscribers[i].Packages[j].Desc+'","OfferID":"'+this.data.Subscribers[i].Packages[j].OfferId+'","COSTO":"'+parseFloat(this.data.Subscribers[i].Packages[j].Price).toFixed(2)+'","RENEWAL":"'+sw1+'","RENEWALACTIVE":'+sw3+',"RENEWALENABLE":'+sw5+'}';
                      contador++;

                      paqueteAnt=this.data.Subscribers[i].Packages[j].OfferId;

                  }
              }
              contador3++;
              paquetes+='],"INDEX":"'+contador3+'","SUBSCRIBER":"'+this.data.Subscribers[i].SubcriberNumber+'"}';
              contador2++;
              contador=0;
            }
          }
          paquetes+=']';

          this.contadorHtml=contador2;
          var objPaquete=JSON.parse(paquetes);
          var sw2=false;
          var sw4=false;
          var sw6=false;
          // var cont111=0;
          for (var i = 0; i < objPaquete.length; i++) {
            sw2=false;
            for (var j = 0; j < objPaquete[i].paquete.length; j++) {
                for (var n = 0; n < this.data.Subscribers.length; n++) {
                    if(this.data.Subscribers[n].Packages!=null && this.data.Subscribers[n].Packages!=""){
                        for (var m = 0; m < this.data.Subscribers[n].Packages.length; m++) {

                            if(this.data.Subscribers[n].Packages[m].OfferId==objPaquete[i].paquete[j].OfferID){
                                if(this.data.Subscribers[n].Packages[m].renewal==true){
                                    sw2=true;
                                    if(this.data.Subscribers[n].Packages[m].renewalActive==true){
                                      sw4=true;
                                    }
                                    if(this.data.Subscribers[n].Packages[m].renewalEnable==true){
                                      sw6=true;
                                    }
                                }
                            }
                        }
                    }
                  }

            objPaquete[i].paquete[j].RENEWAL=sw2;
            objPaquete[i].paquete[j].RENEWALACTIVE=sw4;
            objPaquete[i].paquete[j].RENEWALENABLE=sw6;

          }
        }
        this.paquetes=objPaquete;
        this.loadingScreenService.stopLoading();
      }
      else{
        this.global.notif(data.ErrorDesc);
      }
    });
  }
  recurrenceChange(index,subscriber,offerID,baseOfferID) {
    this.global.validateSession();
    let check1 = document.getElementById("checkbox1_"+index) as HTMLInputElement;
    if(check1.checked==true){
      this.activateRecurrence(subscriber,offerID,baseOfferID,index);
    }
    else{
      this.turnOffRecurrence(subscriber,offerID,baseOfferID,index)
    }
  }
  activateRecurrence(SubscriberId,OfferID,BaseOfferId,index) {

      this.loadingScreenService.startLoading();
      this.services.subscriptionAutomaticRenewalAdd(SubscriberId,OfferID,BaseOfferId,this.token,).subscribe(data =>{
        this.loadingScreenService.stopLoading();
        if(data.HasError ==false){
          this.global.notif(data.Description);
        }
        else{
          this.global.notif(data.ErrorDesc);
          let check1 = document.getElementById("checkbox1_"+index) as HTMLInputElement;
          check1.checked=false;
        }
      });
  }
 turnOffRecurrence(SubscriberId,OfferID,BaseOfferId,index) {
    this.loadingScreenService.startLoading();
    this.services.subscriptionAutomaticRenewalRemove(SubscriberId,OfferID,BaseOfferId,this.token,).subscribe(data =>{
      this.loadingScreenService.stopLoading();
      if(data.HasError ==false){
        this.global.notif(data.Description);
      }
      else{
        this.global.notif(data.ErrorDesc);
        let check1 = document.getElementById("checkbox1_"+index) as HTMLInputElement;
        check1.checked=true;
      }
    });
 }
 ngOnDestroy() {
    this.loadObserver.unsubscribe();
  }
}
